// bao migrate skip
import * as ko from "knockout";
import Bao from "./../../../services/bao-service";
import BaoDialogViewModel from "./../../../factories/bao-dialog";
import baoRouter from "./../../../services/bao-router";
import TabPage from "./../../../factories/tab-page";
import ChecklistFrequencyDistributionDiagramViewModel from "./checklist-frequency-distribution-diagram-view-model";
import "./../../../bindings/bao-tabs";
import "./../../../bindings/bao-date-time-picker";
import "./../../../bindings/bao-date-time-box";
import "./../../../bindings/bao-searcher";
import * as d3 from "d3";
function ChecklistFrequencyDistribution(parent) {
    var self = this;
    self.parent = parent;
    self.Bao = Bao;
    self.Initialized = ko.observable(false);
    self.ReportLoaded = ko.observable(false);
    self.Limit = ko.observable(10);
    self.Models = ko.observableArray([]);
    self.AllModels = ko.observableArray([]);
    self.PageIndexDefault = 0;
    self.PageSizeDefault = 10;
    self.PageIndex = ko.observable(self.PageIndexDefault);
    self.PageSize = ko.observable(self.PageSizeDefault);
    self.TotalRows = ko.observable(0);
    self.Sorting = ko.observable([]);
    self.chart = ko.observable();
    self.IsLoading = ko.observable();
    self.checklistString = self.Bao.Session.GetMessage("msgChecklist");
    self.EndDateTime = ko.observable();
    self.StartDateTime = ko.observable();
    self.RefreshNeeded = false;
    Bao.bindEvent("checkware-tasks:refresh", function () {
        if (!self.parent.TabPage.IsActiveTab()) {
            self.RefreshNeeded = true;
        }
        else {
            self.Refresh();
        }
    });
    self.parent.TabPage.IsActiveTab.subscribe(function (newval) {
        if (self.RefreshNeeded === true) {
            self.Refresh();
        }
    });
    self.ViewModel = ko.observable();
    self.CaptionDatasieriesname = ko.observable("data1");
    self.chart = ko.observable();
    self.chartColors = [];
    self.DiagramDataSet = ko.pureComputed(function () {
        var entries = self.Models();
        var data = {
            x: "x",
            columns: [["data1"], ["x"]],
            types: {
                data1: "bar"
            },
            names: {
                data1: self.CaptionDatasieriesname()
            },
            labels: true,
            color: function (color, d) {
                if (d.index != null && self.chartColors != null) {
                    return self.chartColors[d.index];
                }
                return "#1f77b4";
            }
        };
        var color = ["#d32323", "#e28b14", "#e8e40d", "#b4b41f", "#b7d824", "#58bf1c", "#1bbf52", "#1abf9b", "#1fa5b4", "#1f77b4", "#1f4eb4", "#261fb4", "#551fb4", "#821fb4", "#b41f9b"];
        var colorGrey = "#a3a3a1";
        var colorCount = 0;
        var labelCounter = 1;
        if (entries.length > 0) {
            for (var i in entries) {
                var y = ko.unwrap(entries[i].Count);
                if (typeof y === "undefined" || y === null) {
                    y = 0;
                }
                var label = ko.unwrap(entries[i].ChecklistName);
                if (typeof label === "undefined" || label === null || label == "") {
                    label = self.checklistString() + " " + labelCounter;
                    labelCounter++;
                }
                data.columns[0].push(y);
                data.columns[1].push(label);
                var isOthers = ko.unwrap(entries[i].IsOthers);
                if (isOthers) {
                    self.chartColors.push(colorGrey);
                }
                else {
                    self.chartColors.push(color[colorCount]);
                    if (colorCount > 14) {
                        colorCount = 0;
                    }
                    colorCount++;
                }
            }
        }
        return data;
    });
    self.cDreiChartBinding = ko.observable({
        data: self.DiagramDataSet,
        legend: {
            show: false
        },
        axis: {
            x: {
                type: "category",
                tick: {
                    rotate: 75,
                    multiline: false
                }
            },
            y: {
                tick: {
                    format: function (x) {
                        if (x % 1 > 0) {
                            var tick = d3.selectAll(".c3-axis-y g.tick").filter(function () {
                                var text = d3.select(this).select("text").text();
                                return +text === x;
                            }).style("opacity", 0);
                            return "";
                        }
                        else {
                            return x;
                        }
                    }
                }
            },
            rotated: true
        },
        tooltip: {
            show: false,
            contents: function (d, defaultTitleFormat, defaultValueFormat, color) {
                return "<span>123abc</span>";
            }
        }
    });
    self.DiagramDataSetPie = ko.pureComputed(function () {
        var entries = self.Models();
        var data = {
            columns: [],
            type: "pie",
            names: {
                data1: self.CaptionDatasieriesname()
            },
            labels: true,
            colors: {}
        };
        var color = ["#d32323", "#e28b14", "#e8e40d", "#b4b41f", "#b7d824", "#58bf1c", "#1bbf52", "#1abf9b", "#1fa5b4", "#1f77b4", "#1f4eb4", "#261fb4", "#551fb4", "#821fb4", "#b41f9b"];
        var colorGrey = "#a3a3a1";
        var counter = 0;
        var labelCounter = 1;
        if (entries.length > 0) {
            for (var i in entries) {
                var percent = ko.unwrap(entries[i].Count);
                if (typeof percent === "undefined" || percent === null) {
                    percent = 0;
                }
                var label = ko.unwrap(entries[i].ChecklistName);
                if (typeof label === "undefined" || label === null || label == "") {
                    label = self.checklistString() + " " + labelCounter;
                    labelCounter++;
                }
                label = label + " [" + ko.unwrap(entries[i].Count) + "]";
                data.columns[counter] = [label, percent];
                var isOthers = ko.unwrap(entries[i].IsOthers);
                if (isOthers) {
                    data.colors[label] = colorGrey;
                }
                else {
                    data.colors[label] = color[counter];
                }
                counter++;
            }
        }
        return data;
    });
    self.cDreiChartBindingPie = ko.observable({
        data: self.DiagramDataSetPie,
        legend: {
            show: true
        },
        tooltip: {
            show: false,
            contents: function (d, defaultTitleFormat, defaultValueFormat, color) {
                return "<span>123abc</span>";
            }
        }
    });
    self.IsReportResultEmpty = ko.pureComputed(function () {
        return Boolean(self.ReportLoaded() && typeof self.Models() !== "undefined" && self.Models().length === 0);
    });
    self.GetFrequencyDistributionCategoryReportResult = function (sorting, pageIndex, pageSize, saveFilter) {
        return Bao.post("Module/ChecklistFrequencyDistributionGetAllChecklists", JSON.stringify({
            OnlyCompleted: true,
            fromTime: null
        }));
    };
    self.RefreshModels = function () {
        return self.GetFrequencyDistributionCategoryReportResult(self.Sorting(), self.PageIndex(), self.PageSize(), true).done(function (result) {
            if (result.Result == true) {
                self.Models(result.Models);
                self.TotalRows(result.TotalRows);
            }
        });
    };
    self.resetDefaults = function () {
        self.ReportLoaded(false);
        self.Models([]);
        self.AllModels([]);
        self.PageIndex(self.PageIndexDefault);
        self.PageSize(self.PageSizeDefault);
        self.TotalRows(0);
        self.Sorting([]);
    };
    self.Display = function () {
        parent.TabPage.IsLoading(true);
        self.resetDefaults();
        self.RefreshModels().done(function () {
            self.ReportLoaded(true);
            parent.TabPage.IsLoading(false);
        }).fail(function () {
            self.ReportLoaded(false);
            parent.TabPage.IsLoading(false);
        });
    };
    self.parent.Refresh = function () {
        self.Refresh();
    };
    self.Refresh = function () {
        self.Display();
        self.RefreshNeeded = false;
    };
    self.getChecklistFrequencyDistribution = function () {
        return Bao.post("Module/ChecklistFrequencyDistributionGetAllChecklists", JSON.stringify({
            OnlyCompleted: true,
            fromTime: null
        }));
    };
    self.init = function () {
        var def = $.Deferred();
        if (!self.parent.TabPage.IsActiveTab()) {
            self.RefreshNeeded = true;
            def.resolve();
        }
        else {
            self.getChecklistFrequencyDistribution().done(function (result) {
                ko.map.fromJS(result, self);
                def.resolve();
            });
        }
        return $.when(def, self.checklistString.$deferred).then(function () {
            self.Initialized(true);
        });
    };
    self.MonthDayFormatter = function (dateToFormat) {
        if (dateToFormat.length == 1) {
            dateToFormat = "0" + dateToFormat;
        }
        return dateToFormat;
    };
    self.loaded = function () {
        self.ViewModel(new ChecklistFrequencyDistributionDiagramViewModel(self.TabPage, self.DiagramDataSet, self.DiagramTicks));
        self.Display();
    };
    self.DiagramTicks = ko.pureComputed(function () {
        var entries = self.Models();
        var result = [];
        if (entries.length > 0 && self.TagIsNumeric()) {
            for (var i in entries) {
                var x = Number(i) + 0;
                var label = ko.unwrap(entries[i].InsertDateHtml);
                if (typeof label === "undefined" || label === null) {
                    label = "";
                }
                label = label.substr(0, 10) + label.substr(10, 6);
                result.push([x, label]);
            }
        }
        return result;
    });
    self.getItem = function () { };
}
export default ChecklistFrequencyDistribution;